// src/components/Ui/AnimatedSection.jsx

import React, { useEffect, useRef } from 'react';

const AnimatedSection = ({ children, delay = 0 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('visible'); // yeh class add hogi
          }, delay);
        }
      },
      { threshold: 0.15 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => ref.current && observer.unobserve(ref.current);
  }, [delay]);

  return (
    <div
      ref={ref}
      className="animate-fade-up"
    >
      {children}
    </div>
  );
};

export default AnimatedSection;
 